// Code generated by Wire protocol buffer compiler, do not edit.
// Source: vreo.volt.protocol.RoiConfiguration in roi/roiConfig.proto
@file:Suppress(
  "DEPRECATION",
  "RUNTIME_ANNOTATION_NOT_SUPPORTED",
)

package vreo.volt.protocol

import com.squareup.wire.FieldEncoding
import com.squareup.wire.Message
import com.squareup.wire.ProtoAdapter
import com.squareup.wire.ProtoReader
import com.squareup.wire.ProtoWriter
import com.squareup.wire.ReverseProtoWriter
import com.squareup.wire.Syntax.PROTO_3
import com.squareup.wire.WireField
import com.squareup.wire.`internal`.JvmField
import kotlin.Any
import kotlin.AssertionError
import kotlin.Boolean
import kotlin.Deprecated
import kotlin.DeprecationLevel
import kotlin.Int
import kotlin.Long
import kotlin.Nothing
import kotlin.String
import kotlin.Suppress
import okio.ByteString

/**
 * ROI (Region of Interest) configuration
 *
 * @property bay_id Bay identification number
 * @property enable Enable/disable ROI
 * @property frame_width Frame width in pixels of the base image used for ROI
 * @property frame_height Frame height in pixels of the base image used for ROI
 * @property coordinates ROI shape/polygon coordinates
 */
public class RoiConfiguration(
  @field:WireField(
    tag = 1,
    adapter = "com.squareup.wire.ProtoAdapter#INT32",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "bayId",
    schemaIndex = 0,
  )
  public val bay_id: Int = 0,
  @field:WireField(
    tag = 2,
    adapter = "com.squareup.wire.ProtoAdapter#BOOL",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 1,
  )
  public val enable: Boolean = false,
  @field:WireField(
    tag = 3,
    adapter = "com.squareup.wire.ProtoAdapter#INT32",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "frameWidth",
    schemaIndex = 2,
  )
  public val frame_width: Int = 0,
  @field:WireField(
    tag = 4,
    adapter = "com.squareup.wire.ProtoAdapter#INT32",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "frameHeight",
    schemaIndex = 3,
  )
  public val frame_height: Int = 0,
  @field:WireField(
    tag = 5,
    adapter = "vreo.volt.protocol.RoiRegion#ADAPTER",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 4,
  )
  public val coordinates: RoiRegion? = null,
  unknownFields: ByteString = ByteString.EMPTY,
) : Message<RoiConfiguration, Nothing>(ADAPTER, unknownFields) {
  @Deprecated(
    message = "Shouldn't be used in Kotlin",
    level = DeprecationLevel.HIDDEN,
  )
  override fun newBuilder(): Nothing = throw AssertionError("Builders are deprecated and only available in a javaInterop build; see https://square.github.io/wire/wire_compiler/#kotlin")

  override fun equals(other: Any?): Boolean {
    if (other === this) return true
    if (other !is RoiConfiguration) return false
    if (unknownFields != other.unknownFields) return false
    if (bay_id != other.bay_id) return false
    if (enable != other.enable) return false
    if (frame_width != other.frame_width) return false
    if (frame_height != other.frame_height) return false
    if (coordinates != other.coordinates) return false
    return true
  }

  override fun hashCode(): Int {
    var result = super.hashCode
    if (result == 0) {
      result = unknownFields.hashCode()
      result = result * 37 + bay_id.hashCode()
      result = result * 37 + enable.hashCode()
      result = result * 37 + frame_width.hashCode()
      result = result * 37 + frame_height.hashCode()
      result = result * 37 + (coordinates?.hashCode() ?: 0)
      super.hashCode = result
    }
    return result
  }

  override fun toString(): String {
    val result = mutableListOf<String>()
    result += """bay_id=$bay_id"""
    result += """enable=$enable"""
    result += """frame_width=$frame_width"""
    result += """frame_height=$frame_height"""
    if (coordinates != null) result += """coordinates=$coordinates"""
    return result.joinToString(prefix = "RoiConfiguration{", separator = ", ", postfix = "}")
  }

  public fun copy(
    bay_id: Int = this.bay_id,
    enable: Boolean = this.enable,
    frame_width: Int = this.frame_width,
    frame_height: Int = this.frame_height,
    coordinates: RoiRegion? = this.coordinates,
    unknownFields: ByteString = this.unknownFields,
  ): RoiConfiguration = RoiConfiguration(bay_id, enable, frame_width, frame_height, coordinates, unknownFields)

  public companion object {
    @JvmField
    public val ADAPTER: ProtoAdapter<RoiConfiguration> = object : ProtoAdapter<RoiConfiguration>(
      FieldEncoding.LENGTH_DELIMITED, 
      RoiConfiguration::class, 
      "type.googleapis.com/vreo.volt.protocol.RoiConfiguration", 
      PROTO_3, 
      null, 
      "roi/roiConfig.proto"
    ) {
      override fun encodedSize(`value`: RoiConfiguration): Int {
        var size = value.unknownFields.size
        if (value.bay_id != 0) {
          size += ProtoAdapter.INT32.encodedSizeWithTag(1, value.bay_id)
        }
        if (value.enable != false) {
          size += ProtoAdapter.BOOL.encodedSizeWithTag(2, value.enable)
        }
        if (value.frame_width != 0) {
          size += ProtoAdapter.INT32.encodedSizeWithTag(3, value.frame_width)
        }
        if (value.frame_height != 0) {
          size += ProtoAdapter.INT32.encodedSizeWithTag(4, value.frame_height)
        }
        if (value.coordinates != null) {
          size += RoiRegion.ADAPTER.encodedSizeWithTag(5, value.coordinates)
        }
        return size
      }

      override fun encode(writer: ProtoWriter, `value`: RoiConfiguration) {
        if (value.bay_id != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 1, value.bay_id)
        }
        if (value.enable != false) {
          ProtoAdapter.BOOL.encodeWithTag(writer, 2, value.enable)
        }
        if (value.frame_width != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 3, value.frame_width)
        }
        if (value.frame_height != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 4, value.frame_height)
        }
        if (value.coordinates != null) {
          RoiRegion.ADAPTER.encodeWithTag(writer, 5, value.coordinates)
        }
        writer.writeBytes(value.unknownFields)
      }

      override fun encode(writer: ReverseProtoWriter, `value`: RoiConfiguration) {
        writer.writeBytes(value.unknownFields)
        if (value.coordinates != null) {
          RoiRegion.ADAPTER.encodeWithTag(writer, 5, value.coordinates)
        }
        if (value.frame_height != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 4, value.frame_height)
        }
        if (value.frame_width != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 3, value.frame_width)
        }
        if (value.enable != false) {
          ProtoAdapter.BOOL.encodeWithTag(writer, 2, value.enable)
        }
        if (value.bay_id != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 1, value.bay_id)
        }
      }

      override fun decode(reader: ProtoReader): RoiConfiguration {
        var bay_id: Int = 0
        var enable: Boolean = false
        var frame_width: Int = 0
        var frame_height: Int = 0
        var coordinates: RoiRegion? = null
        val unknownFields = reader.forEachTag { tag ->
          when (tag) {
            1 -> bay_id = ProtoAdapter.INT32.decode(reader)
            2 -> enable = ProtoAdapter.BOOL.decode(reader)
            3 -> frame_width = ProtoAdapter.INT32.decode(reader)
            4 -> frame_height = ProtoAdapter.INT32.decode(reader)
            5 -> coordinates = RoiRegion.ADAPTER.decode(reader)
            else -> reader.readUnknownField(tag)
          }
        }
        return RoiConfiguration(
          bay_id = bay_id,
          enable = enable,
          frame_width = frame_width,
          frame_height = frame_height,
          coordinates = coordinates,
          unknownFields = unknownFields
        )
      }

      override fun redact(`value`: RoiConfiguration): RoiConfiguration = value.copy(
        coordinates = value.coordinates?.let(RoiRegion.ADAPTER::redact),
        unknownFields = ByteString.EMPTY
      )
    }

    private const val serialVersionUID: Long = 0L
  }
}
